/**
 * BiziBaza app
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.1.2
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CommonErrorResonse } from '../model/commonErrorResonse';
import { ExternalLinkView } from '../model/externalLinkView';
import { PayeeAccountView } from '../model/payeeAccountView';
import { PaymentView } from '../model/paymentView';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PaymentsService {

    protected basePath = 'https://dev-backend.bizibaza.com/api/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Returns login link.
     * 
     * @param Token Access token.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public paymentsLoginLinkGet(Token: string, observe?: 'body', reportProgress?: boolean): Observable<ExternalLinkView>;
    public paymentsLoginLinkGet(Token: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExternalLinkView>>;
    public paymentsLoginLinkGet(Token: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExternalLinkView>>;
    public paymentsLoginLinkGet(Token: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (Token === null || Token === undefined) {
            throw new Error('Required parameter Token was null or undefined when calling paymentsLoginLinkGet.');
        }

        let headers = this.defaultHeaders;
        if (Token !== undefined && Token !== null) {
            headers = headers.set('Token', String(Token));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ExternalLinkView>(`${this.basePath}/payments/login_link`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes payee account.
     * 
     * @param Token Access token.
     * @param external_id Unique identifier of payee account given by infrastructure component.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public paymentsPayeeAccountDelete(Token: string, external_id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public paymentsPayeeAccountDelete(Token: string, external_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public paymentsPayeeAccountDelete(Token: string, external_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public paymentsPayeeAccountDelete(Token: string, external_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (Token === null || Token === undefined) {
            throw new Error('Required parameter Token was null or undefined when calling paymentsPayeeAccountDelete.');
        }

        if (external_id === null || external_id === undefined) {
            throw new Error('Required parameter external_id was null or undefined when calling paymentsPayeeAccountDelete.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (external_id !== undefined && external_id !== null) {
            queryParameters = queryParameters.set('external_id', <any>external_id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/payments/payee_account`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns payee account.
     * 
     * @param Token Access token.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public paymentsPayeeAccountGet(Token: string, observe?: 'body', reportProgress?: boolean): Observable<PayeeAccountView>;
    public paymentsPayeeAccountGet(Token: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PayeeAccountView>>;
    public paymentsPayeeAccountGet(Token: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PayeeAccountView>>;
    public paymentsPayeeAccountGet(Token: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (Token === null || Token === undefined) {
            throw new Error('Required parameter Token was null or undefined when calling paymentsPayeeAccountGet.');
        }

        let headers = this.defaultHeaders;
        if (Token !== undefined && Token !== null) {
            headers = headers.set('Token', String(Token));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PayeeAccountView>(`${this.basePath}/payments/payee_account`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates payee account.
     * 
     * @param Token Access token.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public paymentsPayeeAccountPost(Token: string, observe?: 'body', reportProgress?: boolean): Observable<ExternalLinkView>;
    public paymentsPayeeAccountPost(Token: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExternalLinkView>>;
    public paymentsPayeeAccountPost(Token: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExternalLinkView>>;
    public paymentsPayeeAccountPost(Token: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (Token === null || Token === undefined) {
            throw new Error('Required parameter Token was null or undefined when calling paymentsPayeeAccountPost.');
        }

        let headers = this.defaultHeaders;
        if (Token !== undefined && Token !== null) {
            headers = headers.set('Token', String(Token));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<ExternalLinkView>(`${this.basePath}/payments/payee_account`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates payment.
     * 
     * @param Token Access token.
     * @param datetime Client&#x27;s date, time and offset presented in ISO 8601.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public paymentsPaymentPost(Token: string, datetime: string, observe?: 'body', reportProgress?: boolean): Observable<PaymentView>;
    public paymentsPaymentPost(Token: string, datetime: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaymentView>>;
    public paymentsPaymentPost(Token: string, datetime: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaymentView>>;
    public paymentsPaymentPost(Token: string, datetime: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (Token === null || Token === undefined) {
            throw new Error('Required parameter Token was null or undefined when calling paymentsPaymentPost.');
        }

        if (datetime === null || datetime === undefined) {
            throw new Error('Required parameter datetime was null or undefined when calling paymentsPaymentPost.');
        }

        let headers = this.defaultHeaders;
        if (Token !== undefined && Token !== null) {
            headers = headers.set('Token', String(Token));
        }
        if (datetime !== undefined && datetime !== null) {
            headers = headers.set('datetime', String(datetime));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<PaymentView>(`${this.basePath}/payments/payment`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
